import { FieldTypes } from '../../constants/FieldTypes'
import type {
  BloodPressureField,
  DropdownField,
  FieldMap,
  NumberField,
  TextAreaField,
} from '../../types/forms/fields'
import type { EdemaGrade, FetalPosition } from '../encounters/types/prenatal'

export const quickNoteField: FieldMap = {
  name: 'Quick Note',
  children: {
    bloodPressure: {
      type: FieldTypes.BLOOD_PRESSURE,
      placeholder: 'Blood Pressure',
      optional: true,
    } satisfies BloodPressureField,
    pulse: {
      type: FieldTypes.NUMBER,
      placeholder: 'Pulse',
      unit: 'bpm',
      min: 0,
      max: 300,
      optional: true,
    } satisfies NumberField,
    temperature: {
      type: FieldTypes.NUMBER,
      placeholder: 'Temperature',
      unit: '°F',
      step: 0.1,
      precision: 1,
      min: 90,
      max: 110,
      optional: true,
    } satisfies NumberField,
    weight: {
      type: FieldTypes.NUMBER,
      placeholder: 'Weight',
      unit: 'lbs',
      min: 0,
      max: 600,
      optional: true,
    } satisfies NumberField,
    fundalHeightCm: {
      type: FieldTypes.NUMBER,
      placeholder: 'Fundal Height',
      unit: 'cm',
      min: 0,
      max: 50,
      optional: true,
    } satisfies NumberField,
    fetalHeartTones: {
      type: FieldTypes.NUMBER,
      placeholder: 'Fetal Heart Tones',
      unit: 'bpm',
      min: 0,
      max: 300,
      optional: true,
    } satisfies NumberField,
    fetalPosition: {
      type: FieldTypes.DROPDOWN,
      placeholder: 'Fetal Position',
      optional: true,
      options: [
        { id: 'cephalic', text: 'Cephalic' },
        { id: 'breech-frank', text: 'Frank Breech' },
        { id: 'breech-complete', text: 'Complete Breech' },
        { id: 'breech-footling', text: 'Footling Breech' },
        { id: 'transverse', text: 'Transverse' },
        { id: 'oblique', text: 'Oblique' },
        { id: 'not-yet-clinically-relevant', text: 'N/A' },
      ],
    } satisfies DropdownField<FetalPosition>,
    edema: {
      type: FieldTypes.DROPDOWN,
      placeholder: 'Edema',
      optional: true,
      options: [
        { id: 'none', text: 'None' },
        { id: 'trace', text: 'Trace' },
        { id: '1+', text: '1+' },
        { id: '2+', text: '2+' },
        { id: '3+', text: '3+' },
        { id: '4+', text: '4+' },
      ],
    } satisfies DropdownField<EdemaGrade>,
    quickNoteText: {
      type: FieldTypes.TEXTAREA,
      placeholder: 'Brief clinical note…',
      optional: true,
    } satisfies TextAreaField,
  },
}
